type state = {
    isDropoutModalOpen: boolean;
};

import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

const initialState: state = {
    isDropoutModalOpen: false,
};

const dropoutModalSlice = createSlice({
    name: 'customerDropoutModal',
    initialState,
    reducers: {
        setDropoutModalOpen: (state, action: PayloadAction<boolean>) => {
            state.isDropoutModalOpen = action.payload;
        },
    },
});

export const { setDropoutModalOpen } = dropoutModalSlice.actions;
export default dropoutModalSlice.reducer;
